import { getUserPlatform } from '@/api/login'
import { login } from '../../api/website/website'
export default {
  state: {
    projectNo: ''
  },
  getters: {
    projectNo: state => state.projectNo,
    platFormId: state => state.platFormId
  },
  mutations: {
    SET_PROJECT_NO(state, projectNo) {
      state.projectNo = projectNo
    },
    SET_PLATFORM_ID(state, platFormId) {
      state.platFormId = platFormId
    },
  },
  actions: {
    setProjectNo({ commit }, no) {
      commit('SET_PROJECT_NO', no)
    },
    setPlatFormId({ commit }, id) {
      commit('SET_PLATFORM_ID', id)
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js